import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { apiRequest } from '../hooks/useApi.js'
import { useAuth } from '../contexts/AuthContext.jsx'
import { useAnnouncer } from '../contexts/AnnouncerContext.jsx'

export default function LoginScreen() {
  const navigate = useNavigate()
  const { login } = useAuth()
  const { announce, alertSR } = useAnnouncer()

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [errors, setErrors] = useState({})
  const [submitting, setSubmitting] = useState(false)

  function clearErrors() {
    setErrors({})
  }

  function validate() {
    const next = {}
    if (!username.trim()) {
      next.username = 'O nome de usuário é obrigatório.'
    }
    if (!password) {
      next.password = 'A senha é obrigatória.'
    }
    return next
  }

  async function handleSubmit(e) {
    e.preventDefault()
    clearErrors()

    const validation = validate()
    if (Object.keys(validation).length > 0) {
      setErrors(validation)
      alertSR('Por favor, corrija os erros no formulário de login.')
      return
    }

    setSubmitting(true)
    try {
      const data = await apiRequest('POST', '/auth/login', { username, password }, false)
      login(data.access_token)
      announce('Login realizado com sucesso. Bem-vindo!')
      navigate('/menu')
    } catch (err) {
      alertSR(`Erro no login: ${err.message}`)
      setErrors({ username: err.message })
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <section aria-labelledby="login-heading">
      <h2 id="login-heading" tabIndex="-1">Entrar na sua conta</h2>
      <form id="login-form" noValidate onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="login-username">Nome de usuário</label>
          <input
            type="text"
            id="login-username"
            name="username"
            required
            autoComplete="username"
            aria-describedby="login-username-error"
            placeholder="Seu nome de usuário"
            value={username}
            onChange={(e) => { setUsername(e.target.value); if (errors.username) setErrors(p => ({ ...p, username: '' })) }}
            aria-invalid={errors.username ? 'true' : undefined}
          />
          <span id="login-username-error" className="error-msg" role="alert" aria-live="assertive">
            {errors.username || ''}
          </span>
        </div>

        <div className="form-group">
          <label htmlFor="login-password">Senha</label>
          <input
            type="password"
            id="login-password"
            name="password"
            required
            autoComplete="current-password"
            aria-describedby="login-password-error"
            placeholder="Sua senha"
            value={password}
            onChange={(e) => { setPassword(e.target.value); if (errors.password) setErrors(p => ({ ...p, password: '' })) }}
            aria-invalid={errors.password ? 'true' : undefined}
          />
          <span id="login-password-error" className="error-msg" role="alert" aria-live="assertive">
            {errors.password || ''}
          </span>
        </div>

        <button type="submit" className="btn btn-primary" id="login-submit" disabled={submitting}>
          Entrar
        </button>
      </form>

      <p className="form-toggle">
        Não tem conta?{' '}
        <button type="button" className="btn-link" onClick={() => navigate('/register')}>
          Criar uma conta
        </button>
      </p>
    </section>
  )
}
